(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (!productRecommendationsSection) return;

  var productId = productRecommendationsSection.dataset.productId;
  var limit = productRecommendationsSection.dataset.limit;

  // ✅ Add /en only when current path is under /en or exactly /en
  var p = window.location.pathname;
  var isEnglish = (p === "/en") || p.indexOf("/en/") === 0;
  var localePrefix = isEnglish ? "/en" : "";

  var requestUrl = localePrefix + "/recommendations/products"
    + "?section_id=product-recommendations"
    + "&limit=" + encodeURIComponent(limit)
    + "&product_id=" + encodeURIComponent(productId);

  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function () {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;

      var newContent = container.querySelector(".product-recommendations");
      if (!newContent) return;

      productRecommendationsSection.replaceWith(newContent);

      if (typeof initWishlistButtons === "function") initWishlistButtons();
      initProductSlider();
    }
  };
  request.send();
};

// Editor reload handling
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});

// Initial fetch
loadProductRecommendationsIntoSection();

function initProductSlider() {
  const container = document.getElementById("similar-product-slider");
  const left = document.getElementById("slide-left");
  const right = document.getElementById("slide-right");
  if (!container || !left || !right) return;

  const cards = container.querySelectorAll(".similar-card");
  if (!cards.length) return;

  function getSlideAmount() {
    const isMobile = window.innerWidth < 768;

    if (isMobile) {
      // mobile → 2 cards per row → slide by one card
      return cards[0].offsetWidth + 12;
    }

    // desktop → 3 cards per “page”
    const cardWidth = cards[0].offsetWidth;
    const gap = parseInt(getComputedStyle(container).gap) || 0;
    return (cardWidth + gap) * 3;
  }

  left.addEventListener("click", () => {
    container.scrollBy({ left: -getSlideAmount(), behavior: "smooth" });
  });

  right.addEventListener("click", () => {
    container.scrollBy({ left: getSlideAmount(), behavior: "smooth" });
  });
}
initProductSlider();

  } catch(e) { console.error(e); }
})();
})();
